module.exports = __webpack_public_path__ + "static/media/Kingdra_gaussian2.8865bcba.png";